import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { FiltersM, typesApex } from '../../../components/models';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { Meses, obtenerError, Responsables } from '../../../models/Formulacion/indicadores-metas/datos';
import { firstValueFrom } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { IndicadoresMetasService } from '../../../services/seguimiento/indicadores-metas/indicadores-metas.service';
import { MatTableDataSource } from '@angular/material/table';
import { ExcelService } from '../../../services/excel/excel.service';
import { messages } from '../../funciones/mensajes';
import { IMG } from '../../../services/imagen/png';
import moment from 'moment';
import { PlanificacionService } from '../../../services/gestion/planificacion/planificacion.service';
import { PerspectivaService } from '../../../services/gestion/perspectivas/perspectiva.service';
import { ObjetivoService } from '../../../services/gestion/objetivo/objetivo.service';
import { IndicadorService } from '../../../services/gestion/indicadores/indicador.service';
import { ResponsableService } from '../../../services/gestion/responsable/responsable.service';
import { MetaService } from '../../../services/gestion/meta/meta.service';
import { PERMISOS } from '../../../shared/catalogos';

interface CeldaMeta {
  periodo: string;
  meta: string;
  real: string;
  borde: string;
  esNull: boolean;
}

interface FilaTabla {
  ind: any;
  per: string;
  obj: string;
  borderClass: string;
  celdas: CeldaMeta[];
  responsable: string;
}

@Component({
  selector: 'app-indicadores-metas',
  templateUrl: './indicadores-metas.component.html',
  styleUrl: './indicadores-metas.component.css'
})
export class IndicadoresMetasComponent implements OnInit {
  public readonly permisos = PERMISOS;
  private idPlanificacion: number = 0;

  // Filtros
  public Filters = FiltersM;
  public todasPer = true;
  public aniosDisponibles: any = [];
  public perspectives: any = [];
  public selAll = true;
  public responsables: Responsables[] = [];
  public responsables2: any = []
  private semaforo: any = [];
  public tipoGraf = typesApex;
  public etiquetas = [];

  // Variables 
  public indicadoresMostrar: any = [];
  public indicadores: any = [];
  public objectivos: any = [];
  public treemap: any = [];
  public graficas_lineales: any = [{ name: 'ind', series: [['feb-23', 12, 12], ['mar-23', 12, 12]], check: true }];
  public tabOgraf = true; //--------------------------------------------------------------------------------------------------->
  public subtitulo = '';
  public perspectivaSelec = '';
  public indicadoresMos: any = [];
  private edicion: boolean;
  private fechaAct = moment().toDate();
  public viewTablero = false;

  gradient: boolean = false;
  animations: boolean = true;

  colorScheme_balance: any =  ['#FF495C', '#FF8300', '#FFD100', '#0075C9', '#72D54A'];
  colors_lineal = ['#008FFB', '#00E396'];

  labelFormatting(c: any) {
    return `<span> </span>`;
  }


  // **** Variables para el formateo de numeros
  public separador: string = ","; // separador para los miles
  public sepDecimal: string = '.'; // separador para los decimales
  public verCodigo = false;

  constructor(
    public dataService: DataService,
    private translate: TranslateService,
    private cookies: CookieService,
    private excelService: ExcelService,

    private planificacionService: PlanificacionService,
    private responsableService: ResponsableService,
    private objetivoService: ObjetivoService,
    private indicadorService: IndicadorService,
    private metaService: MetaService,
  ) {
    this.obtenerDatos();
  }

  ngOnInit(): void { }

  /** Metodo de escritura de cantidades */
  public formatearnormal(num: any) {
    num = Number(Number(num).toFixed(2));
    num += '';
    var splitStr = num.split('.');
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, '$1' + this.separador + '$2');
    }
    if (splitRight === '.00' || splitRight === '.0')
      return splitLeft;
    return splitLeft + splitRight;
  }

  private async obtenerDatos() {
    this.idPlanificacion = Number(this.cookies.get('idInstitucion'));
    try {

      const planeacionResponse = await this.planificacionService.getPlanificacionByIdGQL(this.idPlanificacion);
      this.obtenerFiltros(planeacionResponse);
      var objetivesId = [];
      for (const per of planeacionResponse.perspectives) {
        this.perspectives.push({
          name: per.name,
          id: per.id,
          check: true,
        });
      }
      // this.perspectives[0].check = true;
      // this.todasPer = false;
      this.perspectives = this.ordenamientoId(this.perspectives);

      const objectives = [];
      for(const per of this.perspectives){
        const obj = await this.objetivoService.getObjectivesByPerspectiveGQL(per.id);
        objectives.push(...obj)
      }
      this.obtenerObjetivos(objectives);

      const indicators = [];
      for(const obj of this.objectivos){
        const ind = await this.indicadorService.getIndicadoresByObjetiveGQL(Number(obj.id));
        indicators.push(...ind)
      }
      this.obtenerIndicadores(indicators.flat());
    } catch (error) {
      // Manejo de errores si alguna petición falla
    }
  }

  private async obtenerFiltros(plan: any) {
    if (plan.institution.acronym === 'IDemo' || plan.institution.acronym === 'Bienestar') {
        //this.verCodigo = true;
    }
    this.edicion = plan.isActive;
    this.aniosDisponibles = Meses.obtenerPeriodos(moment(plan.initial_date).toDate(), moment(plan.end_date).toDate());

    // Agregar visible: true a todos los años y meses
    for (const anio of this.aniosDisponibles) {
      anio.visible = true;
      for (const mes of anio.series) {
        mes.visible = true;
      }
    }

    var periodosSeleccionados = 0;
    for (var i = this.aniosDisponibles.length - 1; i >= 0; i--) {
      for (var j = this.aniosDisponibles[i].series.length - 1; j >= 0; j--) {
        if (periodosSeleccionados < 12) {
          this.aniosDisponibles[i].series[j].check = true;
          periodosSeleccionados++;
        }
      }
      if (periodosSeleccionados === 12) {
        break;
      }
    }

    const sema = this.ordenamientoSem([].concat(plan.signals));
    for (const sem of sema) {
      this.semaforo.push({
        valIn: Number(sem.value_00),
        valfin: Number(sem.value_01),
        color: sem.color[0],
      });
    }

    const response = await firstValueFrom(this.responsableService.getResponsable());
    this.responsables = [];
    for (const res of response) {
      if (res.institution.id === plan.institution.id) {
        if (this.dataService.filtradoIndicadores) {
          if (res.responsibles[0].email === this.dataService.user) {
            this.responsables.push({
              id: res.id,
              nombre: res.name,
              name: res.name,
              check: true,
            });
          }
        } else {
          this.responsables.push({
            id: res.id,
            nombre: res.name,
            name: res.name,
            check: true,
          });
        }
      }
    }
    this.responsables = this.ordenamientoAlf(this.responsables);
    this.responsables2 = new MatTableDataSource(this.responsables);
  }

  private obtenerObjetivos(array: any) {
    var aux = [];
    for (const obj of array) {
      if (this.perspectives.find(per => obj.perspective.id === per.id)) {
        aux.push({
          nombre: obj.name,
          id: obj.id,
          idPer: obj.perspective.id,
        });
      }
    }
    this.objectivos = [];
    this.objectivos = aux;
    this.objectivos = this.ordenamientoId(this.objectivos);
  }

  private obtenerIndicadores(array: any) {
    var aux = [];
    for (const ind of array) {
      if (this.objectivos.find(obj => obj.id === ind.objective.id)) {
        var metas = [];
        for (const met of ind.goals) {
          const date = this.obtFech(met.period);
          metas.push({
            id: met.id,
            period: date,
            value: met.value,
            real: met.real,
          });
        }
        aux.push({
          nombre: ind.name,
          id: ind.id,
          ponderacion: ind.weighing,
          metas: this.ordenamientoMetas(metas),
          objectiveId: ind.objective.id,
          tendencia: ind.tendency,
          fechaIni: ind.initialDate,
          fechaFin: ind.endDate,
          areaId: ind.area.id,
        });
      }
    }
    this.indicadores = [];
    this.indicadores = this.ordenamientoObjId(this.ordenamientoId(aux));
    this.indicadores = this.ordenarPorPerspectiva(this.indicadores);
    this.indicadoresMostrar = [];
    for (const ind of this.indicadores) {
      if (this.Mostrar(ind)) {
        this.indicadoresMostrar.push(ind);
      }
    }
    this.contar_colores();
    this.construirFilasTabla();
    this.viewTablero = true;
  }

  public filasTabla: FilaTabla[] = [];

  private construirFilasTabla() {
  this.filasTabla = this.indicadoresMostrar.map((ind, i) => {
    const per = this.escribirPer(ind, i);
    const obj = this.escribirObj(ind, i);
    const borderClass = per !== '' ? 'borderSup' : '';

    const celdas: CeldaMeta[] = [];
    for (const an of this.aniosDisponibles) {
      for (const mes of an.series) {
        if (mes.check) {
          const meta = this.escribirMeta(mes.periodo, ind);
          const real = this.escribirReal(mes.periodo, ind);
          const realS = this.escribirReal(mes.periodo, ind, 's');
          const metaS = this.escribirMeta(mes.periodo, ind, 's');
          const rend = meta !== '' ? this.rendimiento(mes.periodo, ind) : '';
          celdas.push({
            periodo: mes.periodo,
            meta,
            real,
            borde: meta !== '' ? this.pintarBorde(realS, metaS, rend) : '',
            esNull: real === 'null',
          });
        }
      }
    }

    return { ind, per, obj, borderClass, celdas, responsable: this.obtRes(i) };
  });

  // this.tabOgraf = false;
}

  // Metodos de ordenamiento
  public ordenamientoId(array: any) {
    array.sort(function (a: any, b: any) {
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      return 0;
    });
    return array;
  }

  public ordenamientoObjId(array: any) {
    array.sort(function (a: any, b: any) {
      if (Number(a.objectiveId) > Number(b.objectiveId)) {
        return 1;
      }
      if (Number(a.objectiveId) < Number(b.objectiveId)) {
        return -1;
      }
      return 0;
    });
    return array;
  }

  public ordenamientoMetas(array: any) {
    array.sort(function (a: any, b: any) {
      if ((a.period) > (b.period)) {
        return 1;
      }
      if ((a.period) < (b.period)) {
        return -1;
      }
      return 0;
    });
    return array;
  }

  public ordenamientoAlf(array: any) {
    array.sort(function (a: any, b: any) {
      if ((a.nombre) > (b.nombre)) {
        return 1;
      }
      if ((a.nombre) < (b.nombre)) {
        return -1;
      }
      return 0;
    });
    return array;
  }

  public ordenamientoSem(array: any) {
    array.sort(function (a: any, b: any) {
      if (Number(a.value_00) > Number(b.value_00)) {
        return 1;
      }
      if (Number(a.value_00) < Number(b.value_00)) {
        return -1;
      }
      return 0;
    });
    return array;
  }

  private ordenarPorPerspectiva(array: any) {
    var aux = [];
    for (const per of this.perspectives) {
      for (var i = 0; i < array.length; i++) {
        if (per.id === this.obtenerIdPer(array[i].objectiveId)) {
          aux.push(array[i]);
        }
      }
    }
    return aux;
  }

  // metodos de escritura tabla
  public escribirObj(ind: any, i: any) {
    if (this.indicadoresMostrar.length === 1) {
      return this.obtObj(ind.objectiveId);
    } else {
      if (i != 0) {
        if (Number(ind.objectiveId) != Number(this.indicadoresMostrar[i - 1].objectiveId))
          return this.obtObj(ind.objectiveId);
      } else if (i === 0) {
        return this.obtObj(ind.objectiveId);
      }
    }
    return '';
  }

  public escribirPer(ind: any, i: any) {
    var perid1, perid2;
    for (const obj of this.objectivos) {
      if (obj.id === this.indicadoresMostrar[i].objectiveId) {
        perid1 = obj.idPer;
      }
    }
    if (i != 0) {
      for (const obj of this.objectivos) {
        if (obj.id === this.indicadoresMostrar[i - 1].objectiveId) {
          perid2 = obj.idPer;
        }
      }
      if (perid1 != perid2) {
        return this.obtPer(perid1);
      }
    } else {
      return this.obtPer(perid1);
    }

    return '';
  }

  public escribirMeta(periodo: any, ind: any, sinfor?: any) {
    if (sinfor === 'ss')
      var nombre = '';
    for (const met of ind.metas) {
      nombre = Meses.getMesesN(moment(met.period).month() + 1) + '-' + moment(met.period).format('YY');
      if (nombre === periodo && sinfor === undefined) {
        return '' + this.formatearnormal(met.value);
      } else if (nombre === periodo && sinfor !== undefined) {
        return '' + met.value;
      }
    }
    return ''
  }
  public escribirReal(periodo: any, ind: any, sinfor?: any) {
    var nombre = '';
    for (const met of ind.metas) {
      nombre = Meses.getMesesN(moment(met.period).month() + 1) + '-' + moment(met.period).format('YY');
      if (nombre === periodo && sinfor === undefined) {
        if (met.real === null || met.real === 'null') {
          return 'null'
        }
        return '' + this.formatearnormal(met.real);
      } else if (nombre === periodo && sinfor !== undefined) {
        return '' + met.real;
      }
    }
    return ''
  }

  public pintarBorde(valor: any, meta: any, ind: any) {
    const met = Number(meta), val = Number(valor);
    var porcen = undefined, col = '';
    if (val === 0 && met !== 0 && this.dataService.company_name === 'Unión Popular') {//'Raiffeisen Latina' ){//
      return 'bordeNegro'
    }
    let dat = ind.split('%');
    porcen = Number(dat[0]);
    if (isNaN(val)) {
      porcen = undefined;
    }
    if (porcen !== undefined) {
      var valfin = 0;
      for (const sem of this.semaforo) {
        if (valfin < sem.valfin) {
          valfin = sem.valfin
        }
      }
      if (porcen >= valfin) {
        porcen = valfin - 1;
      }
      for (const sem of this.semaforo) {
        var ab = sem.valIn;
        if (ab !== 0) {
          ab = ab - 0.1;
        }
        if (porcen >= ab && porcen <= sem.valfin) {
          col = sem.color;
          break;
        }
      }
      switch (col) {
        case 'rojo': return 'bordeRojo';
        case 'naranja': return 'bordeNaranja';
        case 'amarillo': return 'bordeAmarillo';
        case 'azul': return 'bordeAzul';
        case 'verde': return 'bordeVerde';
      }
    }
    return 'bordeGrey';
  }
  public rendimiento(periodo: any, ind: any) {
    var nombre = '';
    const metas = ind.metas.filter(meta =>
      Meses.getMesesN(moment(meta.period).month() + 1) + '-' + moment(meta.period).format('YY') === periodo
    );
    //const met = metas[0];
    const met = { real: metas[0].real === null ? null : metas[0].real, value: metas[0].value === null ? null : metas[0].value };

    if (met.real < 0 && met.value >= 0) {
      switch (ind.tendencia) {
        case '-1':
          const sem = this.semaforo.filter(sem => sem.valfin >= 100);
          return sem[0].valfin + ' %';
        case '1':
        case '0':
          return '0 %';
      }
    } else if (met.value < 0.0 && met.real !== null) {
      switch (ind.tendencia) {
        case '-1':
          if (met.real > 0) {
            const sem = this.semaforo.filter(sem => sem.valfin >= 100);
            return 0 + ' %';
          } else if (met.value <= met.real) {
            const sem = this.semaforo.filter(sem => sem.valfin >= 100);
            return sem[0].valfin + ' %';
          } else if (met.value > met.real) {
            rendimiento = Number(((met.real * 100) / met.value).toFixed(1));
            if (rendimiento < 0) { rendimiento = 0; }
            return Number((rendimiento).toFixed(1)) + ' %';
          }
          return '0 %';
        case '1':
        case '0':
          if (met.real > 0) {
            const sem = this.semaforo.filter(sem => sem.valfin >= 100);
            return sem[0].valfin + ' %';
          } else if (met.value >= met.real) {
            const sem = this.semaforo.filter(sem => sem.valfin >= 100);
            return sem[0].valfin + ' %';
          } else if (met.value < met.real) {
            rendimiento = Number(((met.value * 100) / met.real).toFixed(1));
            return Number((rendimiento).toFixed(1)) + ' %';
          }
          return '0 %';
      }
    } else if (met.value !== 0 && met.real !== 0 && met.real !== null) {
      var rendimiento = 0;
      switch (ind.tendencia) {
        case '-1':
          rendimiento = Number(((met.value * 100) / met.real).toFixed(1));
          break;
        case '1':
        case '0':
          rendimiento = Number(((met.real * 100) / met.value).toFixed(1));
          break;
      }
      var valfin = 0;
      for (const sem of this.semaforo) {
        if (valfin < sem.valfin) {
          valfin = sem.valfin;
        }
      }
      if (rendimiento >= valfin) {
        rendimiento = valfin;
      }
      return Number((rendimiento).toFixed(1)) + ' %'
    } else if (met.value !== 0 && met.real === 0) {
      var rendimiento = 0;
      switch (ind.tendencia) {
        case '-1':
          var valfin = 0;
          for (const sem of this.semaforo) {
            if (valfin < sem.valfin) {
              valfin = sem.valfin;
            }
          }
          rendimiento = valfin;
          break;
        case '1':
        case '0':
          rendimiento = 0;
          break;
      }
      return Number((rendimiento).toFixed(1)) + ' %'
    } else if (met.value === 0 && met.real !== null) {
      var rendimiento = 0;
      switch (ind.tendencia) {
        case '-1':
          if (met.real === null) {
            return 0 + ' %';
          } else if (met.real <= 0) {
            return 100 + ' %';
          } else if (met.real > 0) {
            return 0 + ' %';
          }
          break;
        case '1':
        case '0':
          if (met.real === null) {
            return 0 + ' %';
          } else if (met.real >= 0) {
            return 100 + ' %';
          } else if (met.real < 0) {
            return 0 + ' %';
          }
          break;
      }
    } else if (met.value === 0 && met.real === null) {
      switch (ind.tendencia) {
        case '-1':
          return 0 + ' %';
        case '1':
        case '0':
          return 0 + ' %';
      }
    } else if (met.value !== 0 && met.real === null) {
      return '0 %';
    }
    return '';
  }

  private porcentajeMet(periodo: any, ind: any) {
    var nombre = '';
    const metas = ind.metas.filter(meta =>
      Meses.getMesesN(moment(meta.period).month() + 1) + '-' + moment(meta.period).format('YY') === periodo
    );
    const met = metas[0];
    if (met === undefined) {
      return null
    }
    if (met.real === null) {
      return null;
    }
    if (Number(met.real) < 0 && Number(met.value) >= 0) {
      switch (ind.tendencia) {
        case '-1':
          const sem = this.semaforo.filter(sem => sem.valfin >= 100);
          return sem[0].valfin;
        case '1':
        case '0':
          return 0;
      }
    } else if (Number(met.value) < 0.0 && Number(met.real) !== null) {
      switch (ind.tendencia) {
        case '-1':
          if (met.value >= met.real) {
            const sem = this.semaforo.filter(sem => sem.valfin >= 100);
            return sem[0].valfin;
          } else if (met.value < met.real) {
            rendimiento = Number(((met.real * 100) / met.value).toFixed(1));
            if (rendimiento < 0) { rendimiento = 0; }
            return Number((rendimiento).toFixed(1));
          }
          return 0;
        case '1':
        case '0':
          if (met.value <= met.real) {
            const sem = this.semaforo.filter(sem => sem.valfin >= 100);
            return sem[0].valfin;
          } else if (met.value > met.real) {
            rendimiento = Number(((met.value * 100) / met.real).toFixed(1));
            return Number((rendimiento).toFixed(1));
          }
          return 0;
      }
    } else if (Number(met.value) !== 0 && Number(met.real) !== 0 && met.real !== null) {
      var rendimiento = 0;
      switch (ind.tendencia) {
        case '-1':
          rendimiento = Number(((met.value * 100) / met.real).toFixed(1));
          break;
        case '1':
        case '0':
          rendimiento = Number(((met.real * 100) / met.value).toFixed(1));
          break;
      }
      var valfin = 0;
      for (const sem of this.semaforo) {
        if (valfin < sem.valfin) {
          valfin = sem.valfin;
        }
      }
      if (rendimiento >= valfin) {
        rendimiento = valfin;
      }
      return Number((rendimiento).toFixed(1))
    } else if (Number(met.value) !== 0 && Number(met.real) === 0) {
      var rendimiento = 0;
      switch (ind.tendencia) {
        case '-1':
          var valfin = 0;
          for (const sem of this.semaforo) {
            if (valfin < sem.valfin) {
              valfin = sem.valfin;
            }
          }
          rendimiento = valfin;
          break;
        case '1':
        case '0':
          rendimiento = 0;
          break;
      }
      return Number((rendimiento).toFixed(1))
    } else if (Number(met.value) === 0 && Number(met.real) !== null) {
      var rendimiento = 0;
      switch (ind.tendencia) {
        case '-1':
          if (met.real === null) {
            return 0;
          } else if (met.real <= 0) {
            return 100;
          } else if (met.real > 0) {
            return 0;
          }
          break;
        case '1':
        case '0':
          if (met.real === null) {
            return 0;
          } else if (met.real >= 0) {
            return 100;
          } else if (met.real < 0) {
            return 0;
          }
          break;
      }
    } else if (Number(met.value) === 0 && Number(met.real) === null) {
      switch (ind.tendencia) {
        case '-1':
          return 0;
        case '1':
        case '0':
          return 0;
      }
    } else if (Number(met.value) !== 0 && Number(met.real) === null) {
      return 0;
    }
    return '';
  }

  private obtenerIdPer(idObj) {
    for (const obj of this.objectivos) {
      if (obj.id === idObj) {
        return obj.idPer;
      }
    }
  }

  private obtFech(isodate: any) {
    return moment(isodate).toDate();
  }

  // Cambios en filtros
  public cambioAnio(mesSel: any) {
    // Contar los meses seleccionados, excluyendo el mes que se intenta cambiar si ya está seleccionado
    let perSel = 0;
    for (const an of this.aniosDisponibles) {
      for (const mes of an.series) {
        if (mes.check && mes !== mesSel) {
          perSel++;
        }
      }
    }

    if (mesSel.check) {
      // Si ya estaba seleccionado, simplemente desmarcar
      mesSel.check = false;
    } else {
      if (perSel < 12) {
        mesSel.check = true;
      } else {
        Swal.fire({
          title: '' + this.translate.instant('gestion.seguimiento.indicadores.swal1'),
          text: '',
          confirmButtonColor: '#ff6b00',
          confirmButtonText: '' + this.translate.instant('swal.acep')
        });
        return;
      }
    }

    // Actualiza la vista
    this.indicadoresMostrar = [];
    for (const ind of this.indicadores) {
      if (this.Mostrar(ind)) {
        this.indicadoresMostrar.push(ind);
      }
    }
    this.contar_colores();
    this.construirFilasTabla();
  }

  public cambioPer(perSelec: any) {
    if (!this.tabOgraf) {
      // Selección única
      this.perspectives.forEach(per => {
        per.check = per.id === perSelec.id;
      });

      const selected = this.perspectives.find(p => p.id === perSelec.id);
      this.perspectivaSelec = selected?.name || '';
      this.todasPer = false;

    } else {
      if(perSelec !== 'consolidado'){
        this.perspectives.forEach(res =>{ res.name === perSelec.name? res.check = !res.check: res.check = res.check});
        var all = 0;
        this.perspectives.forEach(res =>{ res.check? all++ : all = all });
        if(all === this.perspectives.length){
          this.todasPer = true
        }else{
          this.todasPer = false;
        }
      }else{
        if(this.todasPer){
          this.perspectives.forEach(res =>{ res.check = false});
        }else{
          this.perspectives.forEach(res =>{ res.check = true});
        }
        this.todasPer = !this.todasPer
      }
    }

    if(this.todasPer || perSelec !== 'consolidado'){
      // Actualizar indicadores mostrados
      this.indicadoresMostrar = this.indicadores.filter(ind => this.Mostrar(ind));
      this.contar_colores();
      this.construirFilasTabla();
      this.graficaslineales();
    }
  }

  public selecAllPer() {
    if (!this.tabOgraf) {
      return;
    }

    this.todasPer = !this.todasPer;
    if (this.todasPer) {
      for (const per of this.perspectives) {
        per.check = false;
      }
    } else {
      for (const per of this.perspectives) {
        per.check = false;
      }
      return;
    }
    // Actualizar indicadores mostrados
    this.indicadoresMostrar = [];
    for (const ind of this.indicadores) {
      if (this.Mostrar(ind)) {
        this.indicadoresMostrar.push(ind);
      }
    }
    this.contar_colores();
    this.construirFilasTabla();
  }

  public cambioLider(lidSelec: any) {
    if(lidSelec !== 'consolidado'){
      this.responsables.forEach(res =>{ res.nombre === lidSelec.nombre? res.check = !res.check: res.check = res.check});
      var all = 0;
      this.responsables.forEach(res =>{ res.check? all++ : all = all });
      if(all === this.responsables.length){
        this.selAll = true
      }else{
        this.selAll = false;
      }
    }else{
      if(this.selAll){
        this.responsables.forEach(res =>{ res.check = false});
      }else{
        this.responsables.forEach(res =>{ res.check = true});
      }
      this.selAll = !this.selAll
      
    }
    if( lidSelec !== undefined || this.selAll){
      this.contar_colores();
      this.construirFilasTabla();
    }
  }

  public selectAll() {
    this.responsables.forEach(res => { this.selAll ? res.check = false : res.check = true });
    this.selAll = !this.selAll;

    if (this.selAll) {
      this.indicadoresMostrar = [];
      for (const ind of this.indicadores) {
        if (this.Mostrar(ind)) {
          this.indicadoresMostrar.push(ind);
        }
      }
    }
    this.contar_colores();
    this.construirFilasTabla();
  }

  // Condicionales de filtros
  public numPerSel() {
    var num = 0;
    for (const an of this.aniosDisponibles) {
      for (const mes of an.series) {
        if (mes.check) {
          num++;
        }
      }
    }
    if (num > 1)
      return true;
    return false;
  }

  public numAreSel(): boolean {
    let count = 0;
    for (const res of this.responsables) {
      if (res.check) {
        count++;
      }
    }
    return count > 1;
  }

  public Mostrar(ind: any) {
    // Observar que exista al menos una meta en los periodos
    var perSele = [];
    var metasInd = [];
    var existeMet = false;

    for (const an of this.aniosDisponibles) {
      var mes = an.series.filter(mes => mes.check);
      if (mes.length !== 0) {
        perSele = perSele.concat(mes);
      }
    }
    for (const met of ind.metas) {
      var per = (Meses.getMesesN(moment(met.period).month() + 1) + '-' + moment(met.period).format('YY'));
      if (perSele.find(perS => perS.periodo === per)) {
        existeMet = true;
        break;
      }
    }

    //Observar que la perspectiva este activa
    var existPer = false, perInd;

    for (const obj of this.objectivos) {
      const objectiveId = typeof ind.objectiveId === 'object' ? ind.objectiveId.id : ind.objectiveId;
      if (obj.id === objectiveId) {
        perInd = this.obtPer(obj.idPer);
      }
    }

    if (this.todasPer) {
      existPer = true;
    } else {
      for (const per of this.perspectives) {
        if (per.check && per.name === perInd) {
          existPer = true;
        }
      }
    }

    //que el area este activa
    var areaAct = false;

    for (const area of this.responsables) {
      if (area.id === ind.areaId && area.check) {
        areaAct = true;
        break;
      }
    }

    if (existeMet && existPer && areaAct)
      return true;
    return false;
  }

  public editar(periodo: any, ind: any) {
    var perAct = Meses.obtnerPer(this.fechaAct);
    var perAnt = Meses.obtnerPerAnt(this.fechaAct);
    if (this.edicion) {
      this.dat(periodo, ind);
      return;
    }
    if (Meses.compararPer(perAnt, perAct, periodo)) {
      this.dat(periodo, ind)
    } else {
      Swal.fire({
        title: '' + this.translate.instant('gestion.seguimiento.indicadores.swal2'),
        text: '' + this.translate.instant('gestion.seguimiento.indicadores.swal3'),
        confirmButtonColor: '#ff6b00',
        confirmButtonText: '' + this.translate.instant('swal.acep')
      });
    }
  }

  private async dat(periodo: any, ind: any) {
    var inputValue: any, introdujo: any, guardo = false;
    var nombre = '';
    for (const met of ind.metas) {
      nombre = Meses.getMesesN(moment(met.period).month() + 1) + '-' + moment(met.period).format('YY');
      if (nombre === periodo) {
        inputValue = Number(met.real)
      }
    }

    introdujo = await Swal.fire({
      title: '' + this.translate.instant('gestion.seguimiento.indicadores.swal4'),
      text: "",
      input: 'number',
      inputValue: inputValue,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: '' + this.translate.instant('swal.acep'),
      cancelButtonText: '' + this.translate.instant('swal.cerr'),
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      showCancelButton: true,
      inputValidator: (value) => {
        guardo = true;
        return '';
      }
    });

    if (guardo) {
      for (const indd of this.indicadores) {
        if (Number(indd.id) === Number(ind.id)) {
          for (const met of indd.metas) {
            nombre = Meses.getMesesN(moment(met.period).month() + 1) + '-' + moment(met.period).format('YY');
            if (nombre === periodo) {
              if (introdujo.value !== '') {
                met.real = Number(introdujo.value);
              } else {
                met.real = null;
              }

              

              try {
                await firstValueFrom(this.metaService.patchMetasReal(met));
                this.contar_colores();
                this.construirFilasTabla();
                messages.succesMessageGraph(this.translate.instant('gestion.seguimiento.indicadores.swal5'));
              } catch (err) {
                let er = obtenerError.errorObt(err['error']?.message);
                messages.errorMessageGraph(er);
              }
            }
          }
        }
      }
    }
  }

  // obtencion de nombres
  private obtObj(objectiveid: any) {
    for (const obj of this.objectivos) {
      if (obj.id === objectiveid) {
        return obj.nombre;
      }
    }
  }

  private obtPer(perId: any) {
    for (const per of this.perspectives) {
      if (per.id === perId) {
        return per.name
      }
    }
  }

  // graficas
  private contar_colores() {
    const check = this.perspectives.filter(p => p.check === true);
    if(check.length === 1){
      this.graficaslineales();
    }
    var rojo = 0, naranja = 0, amarillo = 0, azul = 0, verde = 0;
    var rojoI = [], naranjaI = [], amarilloI = [], azulI = [], verdeI = [];
    for (var i = 0; i < this.indicadoresMostrar.length; i++) {
      for (var j = 0; j < this.indicadoresMostrar[i].metas.length; j++) {
        var per = Meses.getMesesN(moment(this.indicadoresMostrar[i].metas[j].period).month() + 1);
        per += '-' + moment(this.indicadoresMostrar[i].metas[j].period).format('YY');
        if (this.muestraPer(per) && this.perAMos(per)) {
          this.subtitulo = per;
          var existPer = false, perInd;
          for (const obj of this.objectivos) {
            if (obj.id === this.indicadoresMostrar[i].objectiveId) {
              perInd = this.obtPer(obj.idPer);
            }
          }
          if (this.todasPer) {
            existPer = true;
          } else {
            for (const per of this.perspectives) {
              if (per.check && per.name === perInd) {
                existPer = true;
              }
            }
          }
          if (existPer) {
            let real = this.escribirReal(per, this.indicadoresMostrar[i], 's');
            let value = this.escribirMeta(per, this.indicadoresMostrar[i], 's');
            switch ('' + this.pintarBorde(real, value, this.rendimiento(per, this.indicadoresMostrar[i]))) {
              case 'bordeRojo': rojo++; rojoI.push(this.indicadoresMostrar[i]); break;
              case 'bordeNaranja': naranja++; naranjaI.push(this.indicadoresMostrar[i]); break;
              case 'bordeAmarillo': amarillo++; amarilloI.push(this.indicadoresMostrar[i]); break;
              case 'bordeAzul': azul++; azulI.push(this.indicadoresMostrar[i]); break;
              case 'bordeVerde': verde++; verdeI.push(this.indicadoresMostrar[i]); break;
            }
          }
        }
      }
    }
    var aux = [];
    aux.push({ name: '' + this.translate.instant('gestion.seguimiento.indicadores.color1'), data: [rojo], indicadores: rojoI });
    aux.push({ name: '' + this.translate.instant('gestion.seguimiento.indicadores.color2'), data: [naranja], indicadores: naranjaI });
    aux.push({ name: '' + this.translate.instant('gestion.seguimiento.indicadores.color3'), data: [amarillo], indicadores: amarilloI });
    aux.push({ name: '' + this.translate.instant('gestion.seguimiento.indicadores.color4'), data: [azul], indicadores: azulI });
    aux.push({ name: '' + this.translate.instant('gestion.seguimiento.indicadores.color5'), data: [verde], indicadores: verdeI });
    this.colorScheme_balance = ['#FF495C', '#FF8300', '#FFD100', '#0075C9', '#72D54A'];
    this.treemap = [];
    this.etiquetas = ['Total'];
    this.treemap = aux;
  }

  private muestraPer(ind: any) {
    // Observar que exista al menos una meta en los periodos
    var perSele = [];
    var existeMet = false;
    for (const an of this.aniosDisponibles) {
      for (const mes of an.series) {
        if (mes.check) {
          perSele.push(mes.periodo);
        }
      }
    }
    for (const perS of perSele) {
      if (ind === perS) {
        existeMet = true;
      }
    }

    if (existeMet)
      return true;
    return false;
  }

  private perAMos(perA: any) {
    var ultPerconDat = '', datos = 0;
    var periodos_mostrados = [];

    for (const an of this.aniosDisponibles) {
      for (const mes of an.series) {
        if (mes.check) {
          periodos_mostrados.push(mes.periodo);
        }
      }
    }

    for (var i = periodos_mostrados.length - 1; i >= 0; i--) {
      for (const ind of this.indicadoresMostrar) {
        for (const met of ind.metas) {
          var peri = Meses.getMesesN(moment(met.period).month() + 1);
          peri += '-' + moment(met.period).format('YY');
          if ((met.real !== 0 && met.real !== null || (met.real === 0 && met.value === 0)) && peri === periodos_mostrados[i]) {
            datos++;
            break;
          }
        }
      }
      if (datos != 0) {
        ultPerconDat = periodos_mostrados[i];
        break;
      }
    }
    if (perA === ultPerconDat)
      return true;
    return false;
  }

  private graficaslineales() {
    this.graficas_lineales = [];
    var graflin: any = [], aux = [], aux2 = [];
    for (var i = 0; i < this.indicadoresMostrar.length; i++) {
      for (var j = 0; j < this.indicadoresMostrar[i].metas.length; j++) {
        var per = Meses.getMesesN(moment(this.indicadoresMostrar[i].metas[j].period).month() + 1);
        per += '-' + moment(this.indicadoresMostrar[i].metas[j].period).format('YY');
        if (this.muestraPer(per)) {
          var existPer = false, perInd;
          for (const obj of this.objectivos) {
            if (obj.id === this.indicadoresMostrar[i].objectiveId) {
              perInd = this.obtPer(obj.idPer);
            }
          }
          if (this.todasPer) {
            existPer = true;
          } else {
            for (const per of this.perspectives) {
              if (per.check && per.name === perInd) {
                existPer = true;
              }
            }
          }
          if (existPer) {
            aux.push([per, Number(this.indicadoresMostrar[i].metas[j].value), Number(this.indicadoresMostrar[i].metas[j].real)]);
          }
        }
      }

      const auxLabels = aux.map(item => item[0]);
      const meta = aux.map(item => item[1]);
      const real = aux.map(item => item[2]);

      const auxData = [
        { name: 'meta', data: meta },
        { name: 'real', data: real }
      ];

      graflin.push(aux)
      this.graficas_lineales.push({ name: this.indicadoresMostrar[i].nombre, series: auxData, labels: auxLabels,check: true });
      aux = [];
      aux2 = [];
      graflin = [];
    }
    for (const per of this.perspectives) {
      if (per.check) {
        this.perspectivaSelec = per.name;
        break;
      }
    }
    this.indicadoresMos = new MatTableDataSource(this.graficas_lineales);
  }

  public cambiarGraf() {
    this.tabOgraf = !this.tabOgraf;

    if (!this.tabOgraf) {
      this.todasPer = false;

      let perspectivasSeleccionadas = 0;
      let ultimaSeleccionada = null;

      for (const per of this.perspectives) {
        if (per.check) {
          perspectivasSeleccionadas++;
          ultimaSeleccionada = per;
        }
      }

      // Si hay mas de una o ninguna perspectiva seleccionada
      if (perspectivasSeleccionadas !== 1) {
        for (const per of this.perspectives) {
          per.check = false;
        }

        // Seleccionar la primera por defecto o la última que estaba seleccionada
        if (ultimaSeleccionada) {
          ultimaSeleccionada.check = true;
          this.perspectivaSelec = ultimaSeleccionada.name;
        } else if (this.perspectives.length > 0) {
          this.perspectives[0].check = true;
          this.perspectivaSelec = this.perspectives[0].name;
        }
      }
    }
  }

  public quitarGrafLin(pos: any) {
    var seMuestran = 0;
    for (const graf of this.graficas_lineales) {
      if (graf.check) {
        seMuestran++;
      }
    }
    if (seMuestran > 1) {
      this.graficas_lineales[pos].check = false;
    } else {

    }
  }

  public selecGrafLin(graf: any) {
    graf.check = !graf.check;
  }

  public obtRes(i: any) {
    var areaId = this.indicadoresMostrar[i].areaId;
    for (const res of this.responsables) {
      if (res.id === areaId) {
        return res.nombre;
      }
    }
    return '';
  }

  //Exportación excel
  public exportar_excel() {
    const title = '' + this.translate.instant('gestion.seguimiento.indicadores.export4');
    var header = ["" + this.translate.instant('gestion.seguimiento.indicadores.titTab1'), "" + this.translate.instant('gestion.seguimiento.indicadores.titTab2'), "" + this.translate.instant('gestion.seguimiento.indicadores.titTab3'), "" + this.translate.instant('gestion.seguimiento.indicadores.titTab6'), "" + this.translate.instant('gestion.seguimiento.indicadores.titTab7')];
    var header2 = ["", "", "", "", ""];
    for (const an of this.aniosDisponibles) {
      for (const mes of an.series) {
        if (mes.check) {
          header.push("" + this.translate.instant('gestion.seguimiento.indicadores.titTab4'));
          header.push("" + this.translate.instant('gestion.seguimiento.indicadores.titTab8'));
          header2.push("" + mes.periodo);
          header2.push("");
        }
      }
    }
    var data = [];
    var aux = [];
    for (var i = 0; i < this.indicadoresMostrar.length; i++) {
      aux.push(this.escribirPer(this.indicadoresMostrar[i], i));
      aux.push(this.escribirObj(this.indicadoresMostrar[i], i));
      aux.push((this.verCodigo ? 'Código | ' : '') + '' + this.indicadoresMostrar[i].nombre);
      aux.push(this.indicadoresMostrar[i].ponderacion);
      aux.push(this.obtRes(i));
      for (const an of this.aniosDisponibles) {
        for (const mes of an.series) {
          if (mes.check) {
            var real = ((this.escribirReal(mes.periodo, this.indicadoresMostrar[i], 'ss')));
            aux.push(this.escribirMeta(mes.periodo, this.indicadoresMostrar[i], 'ss'));
            if (real === '') {
              aux.push(['', null]);
            } else {
              aux.push(real === 'null' ? [0, null] : [real, this.porcentajeMet(mes.periodo, this.indicadoresMostrar[i])]);
            }
          }
        }
      }
      data.push(aux);
      aux = [];
    }
    const NomArch = '' + this.translate.instant('gestion.seguimiento.indicadores.export5');
    this.excelService.generateExcelIndicadores(title, header, header2, data, NomArch, this.semaforo);
  }

  public exportarImg(dat, graf) {
    document.getElementById('cargando_exportar').style.display = 'block';

    var grafica: string = "";
    var name: string = "";
    grafica = 'graf' + dat;
    name = '' + graf.name;

    IMG.exportimagenes(grafica, name)
      .then(() => {
        document.getElementById('cargando_exportar').style.display = 'none';
        messages.succesMessageGraph(this.translate.instant('gestion.seguimiento.indicadores.exportSuccess'));
      })
      .catch(error => {
        document.getElementById('cargando_exportar').style.display = 'none';
        messages.errorMessageGraph(this.translate.instant('gestion.seguimiento.indicadores.exportError'));
      });
  }

  public borrarFiltros(){
    this.todasPer = true;
    this.selAll = true;
    this.tabOgraf = true;

    // Obtiene todas las series en un solo arreglo
    const todasLasSeries = this.aniosDisponibles.flatMap(item => item.series);

    // Primero desactiva todas
    todasLasSeries.forEach(serie => serie.check = false);

    // Activa las últimas N
    todasLasSeries
      .slice(-12)
      .forEach(serie => serie.check = true);

    this.indicadoresMostrar = [];
    for (const ind of this.indicadores) {
      if (this.Mostrar(ind)) {
        this.indicadoresMostrar.push(ind);
      }
    }
    this.contar_colores();
    this.construirFilasTabla();
  }

  selectIndicadores(selec){
    const indicadores = this.treemap[selec.serie].indicadores;
    
    var html = '<div class="w3-row">'+
    '<div class="w3-row">'+
    '  <div style="text-align: justify; margin-left: 1vw; margin-right: 2vw;"> Indicadores asociados </div>'+
    '</div>'+
    '<mat-list style="text-align: justify; margin-left: 2vw; margin-right: 2vw;">';

    for(const ind of indicadores){
      html += '<div mat-line style="text-align: justify; margin-left: 2vw; margin-right: 2vw;">'+
      '<span style="color: #ff6b00">&#8226;</span>'+
      ' '+ind.nombre+
      '</div>';
    }
    html += '</mat-list>'+'</div>';

    var ancho = 'auto';

    Swal.fire({
      title: '',
      html: html,
      showConfirmButton: false,
      width: ancho+'',
    });

  }

}
